module.exports = __webpack_public_path__ + "img/no_order.112f6560.svg";